import { render, staticRenderFns } from "./RcvPD_Details.vue?vue&type=template&id=00be09b7"
import script from "./RcvPD_Details.vue?vue&type=script&lang=js"
export * from "./RcvPD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports